exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  padding-bottom: 45px;\n  background: rgba(0, 0, 0, 0.2); }\n\n.appVersion {\n  font-size: 0.7em;\n  position: fixed;\n  bottom: -10px;\n  right: 15px;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/lora-root.styles.scss
// module id = ../../../../../src/app/lora-root.styles.scss
// module chunks = main